<template>
    <div class="container">
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Φίλτρα αναζήτησης
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <!-- <v-row>
                        <v-col cols="12" sm="6">
                            <v-menu
                                v-model="menu1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="documentIssueDateStartFilter"
                                        label="Ημερομηνία έκδοσης (Από)"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="documentIssueDateStartFilter"
                                    @input="menu1 = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="documentIssueDateStopFilter"
                                        label="Ημερομηνία έκδοσης (Έως)"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="documentIssueDateStopFilter"
                                    @input="menu2 = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row> -->

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-bind:items="branches" 
                                v-model="branchFilter"
                                return-object
                                
                                item-text="name" 
                                label="Υποκατάστημα"
                                clearable>
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-autocomplete 
                                v-bind:items="processedProducts" 
                                v-model="productFilter"
                                return-object
                                
                                item-text="fullDescription" 
                                label="Κωδικός είδους"
                                clearable>
                            </v-autocomplete>
                        </v-col>


                    </v-row>

                                        <v-row class="my-3" cols="12" align="center" justify="center">
                        <v-btn 
                            color="success" 
                            rounded
                            elevation="2"
                            class="mx-2 px-5 font-weight-bold white--text"
                            @click="getData" 
                            :loading="getDataButtonDisabled"
                        >
                            <v-icon left size="20">mdi-magnify</v-icon>
                            <span>ΑΝΑΖΗΤΗΣΗ</span>
                        </v-btn>

                        <table-export-menu
            title="Υπόλοιπα υποκαταστημάτων"
            :headers="headers"
            :items="rows"
            button-class="mx-2"
          />
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>

        </v-expansion-panels>

        
        <!-- <v-row class="my-2" cols="12" align="center" justify="center">
            <v-btn 
                class="mx-2"
                color="warning" 
                @click="getExcel" 
                v-bind:loading="getExcelButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΕΞΑΓΩΓΗ</span>
            </v-btn>
        </v-row> -->
        
        <v-row class="my-2">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="rows"
                    :loading="loading"
                    loading-text="Φόρτωση αποθεμάτων..."
                    no-data-text="Δεν υπάρχουν δεδομένα"
                    :sort-by="['branch_name', 'product_code']"
                    :sort-desc="false"
                    class="elevation-1 text-no-wrap"
                    disable-pagination
                    disable-filtering
                    hide-default-footer>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    
export default {
    
    data() {
        return {
            loading: true,
            // filters
            menu2: null,
            menu1: null,

            branches: [],
            products: [],
            
            branchFilter: null,
            productFilter: null,

            customer: {},
            customerNotEditable: false,

            selectAccountDialog: false,
            selectAccountDialogEntries: [],
            selectAccountDialogShownFor: '',


            headers: [
                {
                    text: 'Υποκατάστημα',
                    align: 'start',
                    value: 'branch_name',
                },
                {
                    text: 'Κωδ. Είδους',
                    align: 'start',
                    value: 'product_code'
                },
                {
                    text: 'Είδος',
                    align: 'start',
                    value: 'product_description',
                },
                {
                    text: 'Απόθεμα',
                    align: 'start',
                    value: 'stock_count'
                }
            ],
            rows: [],
            branches: [],

            getDataButtonDisabled: false,
            getExcelButtonDisabled: false,
        }
    },

    mounted() {
       this.initialize()
    },

    computed: {
        processedProducts() {
            return this.products.map(i => {
                return { 
                    id: i.id,
                    fullDescription : `(${i.code}) ${i.description}`,
                    description: i.description,
                    code: i.code
                }
            })
        }
    },

    methods: {

        

        initialize() {

            axios.all([
                axios.get('/api/products'),
                axios.get('/api/company')
            ]).then(
                axios.spread(
                (
                    productsResponse, 
                    branchesResponse, 
                ) => {
                    this.products = productsResponse.data
                    this.branches = branchesResponse.data.branches

                })).catch(error => { console.log(error) })
                 

            this.getData()
        },

        axiosDownload(url, params, filename) {
            this.getExcelButtonDisabled = true;

            console.log('btn disabled')
            
            axios({
                url: url, 
                params: params,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
                this.getExcelButtonDisabled = false
            // link.remove();
            // url.remove();
            }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
        
                
        
      },

        getRequestParams() {
            return {
                branch_id: this.branchFilter?.id ?? null,
                product_id: this.productFilter?.id ?? null
            }

        },

        getData() {
            this.loading = true;
            this.getDataButtonDisabled = true;
            axios.get(
                '/api/products/branch-stocks', 
                {
                    params: this.getRequestParams()
                }
            ).then(response => this.rows = response.data)
            .finally(() => {
                this.getDataButtonDisabled = false;
                this.loading = false;
            })
        },

        getExcel() {
            this.axiosDownload('/api/products/branch-stocks/export', this.getRequestParams(), 'arxeio.xlsx')
        },
    }
}
</script>